/**
 * @desc 基座 sea 模块化
 * @time 2023-07-31 15:38:51
 * @user simxin
 */

import './variable';
import './initLanguage';
import Sea from './sea';
import { mountMonitor } from '@src/monitor';
import { usePortalStore } from '@src/store';
import { loadPortal } from '@src/component/loading';
import { rqeuestPredependeAPI, requestConsole } from '@src/utils/api';
import { initI18n } from '../translate';
import { initVersion } from '../version/version';

export const mount = cb => {
  initI18n();

  initVersion();

  /**
   * @desc 登录前，加载监控。 可以监控到登录相关问题，上报到rum。
   */
  mountMonitor();

  /**
   * @desc 初始加载状态
   */
  loadPortal();
  /**
   * @desc 并行处理依赖
   */
  Promise.all([mountSea(), mountApi()]).then(ret => {
    // 检查基础依赖是否成功
    const hasBasicError = ret.some(e => !e);

    // 在登录完成后执行 mountConsole
    mountConsole().then(consoleResult => {
      // 保持原有逻辑：任何一个模块失败都设置错误状态
      if (hasBasicError || !consoleResult) {
        const { setErrorPortal } = usePortalStore.getState();
        setErrorPortal(true);
      }

      cb();
    });
  });
};

/**
 * @desc sea 模块化
 */
export const mountSea = async () => {
  return new Promise(resolve => {
    /**
     * @desc 加载 sea
     */
    Sea(window);

    /**
     * @desc 配置 sea 模块依赖基础路径
     */
    seajs.config({
      base: window.AVSTATIC_PATH,
    });

    /**
     * @desc sea 模块加载
     */
    seajs.use(
      `seaup${window.AVQC_COMMIT ? `.${window.AVQC_COMMIT}` : ''}`,
      () => {
        /**
         * @desc router 模块初始化
         * @remark 适配云控制台逻辑
         */
        seajs.require('router').init();
        seajs.require('reactSupport').useReact16(() => {});
        resolve(true);
      },
    );
  });
};

/**
 * @desc 获取前置接口数据
 */
export const mountApi = async () => {
  return new Promise(resolve => {
    rqeuestPredependeAPI().then(ret => {
      resolve(ret);
    });
  });
};

/**
 * @desc 获取应用数据
 */
export const mountConsole = async () => {
  return new Promise(resolve => {
    requestConsole().then(ret => {
      resolve(ret);
    });
  });
};
